export const vehicleStatusesDto = [
  'AVAILABLE',
  'PLANNED',
  'ENROUTE',
  'OUT_OF_ORDER',
] as const;

export type VehicleStatusDto = (typeof vehicleStatusesDto)[number];
